(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('deliveryRequest', {
                parent: 'module',
                url: '/delivery-request',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/delivery/delivery-request.html',
                        controller: 'DeliveryRequestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).state('supplierDeliveryRequest', {
                parent: 'module',
                url: '/supplier-delivery-request',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/delivery/supplier-delivery-request.html',
                        controller: 'SupplierDeliveryRequestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
